import React from 'react';

interface FeatureCardProps {
    image: string;
    title: string;
    description: string;
    icon?: React.ReactNode;
}

export const FeatureCard: React.FC<FeatureCardProps> = ({ image, title, description }) => {
    return (
        <div className="flex flex-col items-center px-8 pt-8 pb-12 w-full max-w-[384px] bg-[#ffa07a] rounded-2xl shadow-sm hover:shadow-lg hover:scale-[1.01] transition-all duration-300">
            <div className="flex flex-col items-center">
                <img loading="lazy" src={image} alt={title} className="object-contain w-[200px] aspect-square" />
            </div>
            {/* Title - Switzer Semibold */}
            <h3 className="font-switzer mt-6 text-2xl font-semibold text-center text-[#212121]">{title}</h3>
            {/* Description - Inter */}
            <p className="font-inter mt-4 text-base md:text-lg leading-relaxed text-center text-[#212121]">{description}</p>
        </div>
    );
};